import { render, staticRenderFns } from "./full-search-input.vue?vue&type=template&id=22b89306"
import script from "./full-search-input.vue?vue&type=script&lang=js"
export * from "./full-search-input.vue?vue&type=script&lang=js"
import style0 from "./full-search-input.vue?vue&type=style&index=0&id=22b89306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports